
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class NotClothing extends SupplierForm {
  form = {
    factoryInfo: {
      developmentInfo: {
        playVersionTime: null as number | null,
      },
    },
  };
  get rules(): ElementUIFormRules {
    return this.getFieldsRules(["factoryInfo.developmentInfo.playVersionTime"]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
}
